// TODO: Patty cooking interval creating issue - patty re appearing as the interval is not clearing on patty remove

import test1 from "../../assets/images/test1.svg";
import test2 from "../../assets/images/test2.svg";
import test3 from "../../assets/images/test3.svg";
import TimerCircle from "../timerCircle";
import { get } from "lodash";
import { useDrop, useDrag } from "react-dnd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  updateGrillQueue,
  increaseMoves,
  updateBurntPatty,
  increasePattiesPlaced,
} from "../../store/ingredient";
// Styles
import "./styles.scss";
import { useEffect, useRef, useState } from "react";
import { PAUSE_TIMER_EVENT, RESUME_TIMER_EVENT } from "../../constants/const";

const GrillItem = (props) => {
  const dispatch = useDispatch();
  const [time, setTime] = useState(0);
  const [p, setP] = useState("pattyUnCooked");
  const grillQueue = useSelector(
    (state) => get(state, "ingredients.grillQueue", []),
    shallowEqual
  );
  const timeInterval = useRef()
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "ingredient",
      item: {
        index: props.itemIndex,
        name: grillQueue[props.itemIndex],
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (item, monitor) => { },
    }),
    [grillQueue]
  );

  const pattyType = () => {
    if (0 <= time && time < 10) return test1;
    if (time >= 10 && time <= 25) return test2;
    if (time > 25) return test3;
    else return test3;
  };

  const triggerPattyCountdown = () => {
    timeInterval.current = setInterval(() => {
      setTime(time => time + 1);
    }, 1000);
  }

  const handlePauseTimer = () => {
    clearInterval(timeInterval.current)
  }

  useEffect(() => {
    if (time === 0) {
      setP("pattyUnCooked");
      dispatch(
        updateGrillQueue({
          index: props.itemIndex,
          value: "pattyUnCooked",
        })
      );
    }
    if (time === 10) {
      setP("pattyCooked");

      dispatch(
        updateGrillQueue({
          index: props.itemIndex,
          value: "pattyCooked",
        })
      );
    }
    if (time === 25) {
      setP("pattyOverCooked");

      dispatch(
        updateGrillQueue({
          index: props.itemIndex,
          value: "pattyOverCooked",
        })
      );

      dispatch(
        updateBurntPatty({
          burnt: true
        })
      )
    }
    if (time > 25) return;
    triggerPattyCountdown()

    return () => clearInterval(timeInterval.current);
  }, [time]);

  useEffect(() => {
    window.addEventListener(PAUSE_TIMER_EVENT, handlePauseTimer)
    window.addEventListener(RESUME_TIMER_EVENT, triggerPattyCountdown)
    return () => {
      window.removeEventListener(PAUSE_TIMER_EVENT, handlePauseTimer)
      window.removeEventListener(RESUME_TIMER_EVENT, triggerPattyCountdown)
    }
  }, [])

  return (
    <div ref={drag} style={{ transform: 'translate(0, 0)' }}>
      <img src={pattyType()} className="image" alt="" />
    </div>
  );
};

function ReadyTray(props) {
  const grillQueue = useSelector(
    (state) => get(state, "ingredients.grillQueue", []),
    shallowEqual
  );

  const dispatch = useDispatch();
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    setQueue(grillQueue);
  }, []);

  const dropPattyToGrill = (item) => {
    dispatch(increaseMoves());
    dispatch(increasePattiesPlaced())
    for (var i = 0; i < grillQueue.length; i++) {
      if (!grillQueue[i]) {
        dispatch(updateGrillQueue({ index: i, value: "pattyUnCooked" }));
        break;
      }
    }
  };

  const [{ isOver }, drop] = useDrop({
    accept: "patty",
    drop: (item, monitor) => dropPattyToGrill(item),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  return (
    <div className={`ready-tray-style ${props.className || ''}`}>
      <div className="cooked-section justify-content-center">
        {
          <div className="patty row" ref={drop}>
            {grillQueue.map((item, index) => (
              <div className="col-4 patty-drop-zone text-center" key={index}>
                {item && (
                  <GrillItem itemIndex={index} pattyType={item}></GrillItem>
                )}
              </div>
            ))}
          </div>
        }
      </div>
      <div className="timer-container row px-4">
        {grillQueue.map((item, index) => (
          <div className="col-4 justify-content-center">
            {item && <TimerCircle time="30" start={true} />}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ReadyTray;
